// extracted by mini-css-extract-plugin
export default {"wrapper":"style_wrapper__iRnh6","title":"style_title__7Z+My","text":"style_text__2Sd-N","navigate":"style_navigate__taTOF"};